export default "__VITE_ASSET__CvoEM8UE__"